<div class="container-workers">
  <div class="container-workers__wrapper">
      <div class="header">
          <h1 class="header__title">
              {{'filesDDD'|translate}}
          </h1>

          <p-tabMenu
              [model]="tabMenu"
              [activeItem]="activeTabOption"
              class="header__tab-menu"
          ></p-tabMenu>
      </div>

      <div class="content">
          <div class="content__filters">
              <div class="left">
                  <div class="content__filters__search-box">
                      <i class="pi pi-search icon"></i>
                      <input
                          [(ngModel)]="searchFilesValue"
                          (ngModelChange)="searchFilesValue$.next($event)"
                          type="text"
                          pInputText
                          [placeholder]="'labels.search'|translate"
                      >
                  </div>
                  <app-date-picker
                    [(ngModel)]="selectedDate"
                    (ngModelChange)="onChangeFilters()"
                    selectionMode="range"
                    [maxRangeDays]="180"
                    [maxSelectableDays]="180"
                    [label]="'timeRange'| translate"
                  ></app-date-picker>
              </div>
          </div>

          <ng-container *ngTemplateOutlet="tableTemplate; context: { $implicit: currentListPageData }"></ng-container>

          <div class="content__footer">
              <div class="left">
                  <ng-container *ngIf="checkedRow()?.length">
                      <span class="count-checked-row">{{ checkedRow()?.length }} {{'labels.selected'|translate}}</span>
                      <button (click)="downloadFiles()" class="button-submit-checked-row">
                          <span>
                              {{ 'download' | translate }}
                          </span>
                      </button>
                  </ng-container>
              </div>
              <div class="right">
                  <p-paginator
                      #paginator
                      [rows]="rowsPerPage"
                      [totalRecords]="totalRecordsDisplayedList"
                      [rowsPerPageOptions]="[10, 20, 50, 100]"
                      (onPageChange)="onChangePaginate($event)"
                  ></p-paginator>
              </div>
          </div>

      </div>
  </div>
</div>

<ng-template #tableTemplate let-data>
  <div #containerList class="content__list">
      <p-table
          [value]="data"
          [scrollable]="true"
          [scrollHeight]="listHeight"
      >
          <ng-template pTemplate="header">
              <tr>
                  <th class="name-column" style="min-width: 300px; width: 300px;">
                      <p-checkbox
                          (ngModelChange)="onChangeValueCheckedAll($event)"
                          [(ngModel)]="isCheckedAll"
                          [binary]="true"
                      ></p-checkbox>
                      <span style="text-transform: capitalize;">
                        {{ activeView === VIEW.Drivers ? ('labels.driver' | translate) : ('labels.vehicle' | translate) }}
                      </span>
                  </th>
                  <th style="min-width: 400px; width: 400px;">{{'file'|translate}}</th>
                  <th style="min-width: 200px; width: 200px;">{{'fileTableTimeFrom'|translate}}</th>
                  <th style="min-width: 200px; width: 200px;">{{'fileTableTimeTo'|translate}}</th>
                  <th style="min-width: 80px; width: 80px;">{{'download'|translate}}</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
              <tr
                class="content__list__item"
              >
                  <td class="name-column">
                      <p-checkbox
                          (click)="$event.stopPropagation()"
                          [(ngModel)]="item.isChecked"
                          [binary]="true"
                      ></p-checkbox>
                      <span>
                        {{ activeView === VIEW.Drivers ? (item.data.Driver.FN + ' ' + item.data.Driver.LN) : item.data.Vehicle?.Nm }}
                      </span>
                  </td>
                  <td>{{item.data.FileName || '-'}}</td>
                  <td>{{ item.data.DateFrom ? (item.data.DateFrom | date: 'dd.MM.yyyy HH:mm:ss') : '-' }}</td>
                  <td>{{ item.data.DateTo ? (item.data.DateTo | date: 'dd.MM.yyyy HH:mm:ss') : '-' }}</td>
                  <td>
                    <button (click)="downloadFiles([item])" class="download-single-file">
                      <i class="pi pi-download icon"></i>
                    </button>
                  </td>
              </tr>
          </ng-template>
      </p-table>

      <div *ngIf="isLoading" class="content__list__loader">
        <p-skeleton *ngFor="let item of [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]" height="3.6rem"></p-skeleton>
      </div>
  </div>
</ng-template>
